<div class="flex min-h-0 flex-1 flex-col gap-6">
  <lib-baa-scroll-container>
    <div class="flex flex-col gap-6">
      <div
        class="flex flex-col items-center gap-2 rounded-3xl bg-gradient-to-br from-[#f8fcff] to-[#f0f8ff] px-4 py-5 text-center"
      >
        <svg-icon size="3xl" key="px-96-success" class="self-center"></svg-icon>
        <div class="typo-h1 text-text-primary">{{ 'express_app_baa_request_sent_heading' | translate }}</div>
        <div class="typo-h4-light text-text-secondary">{{ 'express_app_baa_request_sent_description' | translate }}</div>
        <div class="typo-h5-medium mt-2 w-full rounded-2xl bg-background-white py-5 text-center">
          <p class="typo-h3-medium text-text-primary">{{ signerFullName() }}</p>
          <p class="typo-h4-light-line-height-20 mt-1 text-text-secondary">{{ signerEmail() }}</p>
        </div>
      </div>
    </div>
  </lib-baa-scroll-container>

  <button class="btn-primary w-full shrink-0 justify-center" type="button" (click)="onDone()">
    {{ 'express_app_baa_request_sent_done_button' | translate }}
  </button>
</div>
